/* eslint-disable react-hooks/exhaustive-deps */
import React, { useMemo, useState } from "react";
import "./ExploreBrand.css";
import splendidWhite from "../../assets/images/WhiteLogo/logo_type2.png";
import footerBanner from "../../assets/images/footer_banner.jpg";
import brandBanner from "../../assets/images/brand_banner.jpg";
import DiamondIcon from "../../assets/images/diamond.svg";
import {
  getImageUrl,
  getMetaValue,
  isValidArray,
  isValidNumber,
  isValidYoutubeUrl,
} from "../../utils/Functions/Filter";
import { BRAND_CARD_BENEFITS } from "../../Constant";
import NewLoader from "../../Components/Loader";
import YTPlayer from "react-player";
const BrandPage = ({ brand = {} }) => {
  const { default_creator_commission, default_mark_down } = brand;
  const brandBenefits = useMemo(
    () =>
      BRAND_CARD_BENEFITS.map((x) => getImageUrl(brand?.brand_page_image_urls, x)).filter((x) => x),
    [brand.brand_id]
  );
  const percentage = isValidNumber(default_creator_commission)
    ? Number(default_creator_commission)
    : 50;
  const commission = useMemo(
    () => (isValidNumber(default_mark_down) ? (default_mark_down / 100) * percentage + "%" : "-"),
    [default_mark_down, percentage]
  );
  if (!brand.brand_id) return <NewLoader />;

  const banner_image = getImageUrl(brand?.brand_page_image_urls, "banner") || brandBanner;
  const footer_banner = getImageUrl(brand?.brand_page_image_urls, "footer") || footerBanner;
  const banner_title = getMetaValue(brand?.brand_content_meta, "banner_title") || "-";
  const banner_description = getMetaValue(brand?.brand_content_meta, "banner_description") || "-";
  const footer_li =
    getMetaValue(brand?.brand_content_meta, "footer_description") &&
    getMetaValue(brand?.brand_content_meta, "footer_description")
      ?.split("\n")
      ?.map((item) => item.trim().slice(2));
  const yt = getMetaValue(brand?.brand_content_meta, "yt_footer_video");
  const yt_video = isValidYoutubeUrl(yt) ? yt : "";

  return (
    <section className="single_brand_page">
      <div className="single_brand_container">
        <div className="logo_container">
          <img src={getImageUrl(brand.brand_page_image_urls, "logo")} alt="" />
        </div>
        <div className="web-banner-view">
          <div className="web-banner-card">
            <div className="banner-content-section">
              <h2 className="title">{banner_title}</h2>
              <p className="para">{banner_description}</p>
              <div className="explore-card-commission">
                <p>Commission: {commission}</p>
              </div>
              <a
                className="brand_button_container"
                href={`https://creators.splendid.app/explore?brand_id=${brand.brand_id}`}
              >
                Sign up Here
              </a>
            </div>
            <div className="banner-image-section">
              <img src={banner_image} alt="banner-image" />
            </div>
          </div>
        </div>
        <div className="mobile-view">
          <div className="card">
            <h2 className="title mb-3">{banner_title}</h2>
            <p className="para">{banner_description}</p>
            <div className="explore-card-commission mt-4">
              <p>Commission: {commission}</p>
            </div>
            <a
              className="brand_button_container mt-4"
              href={`https://creators.splendid.app/explore?brand_id=${brand.brand_id}`}
            >
              Sign up Here
            </a>
          </div>
          <div className="banner_div">
            <div
              className="banner_container"
              style={{
                backgroundImage: `url(${banner_image})`,
              }}
            />
          </div>
        </div>
        <div className="brand_title">
          <h2 className="title_2">What are the benefits of joining?</h2>
        </div>
        <div className="brand-benefits-container">
          <div className="col-md-12">
            <div className="row">
              {brandBenefits.map((item, i) => (
                <div className="col-sm-4 brand_individual_card" key={i}>
                  <img src={item} alt="" />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      <div className="single_brand_footer_container">
        <div className="creator_brand_section">
          <div className="row">
            <div className="col col-md-6">
              <h3 className="title">What do I need to do as a creator?</h3>
              <ul>
                {isValidArray(footer_li)
                  ? footer_li.map((item, i) => (
                      <li key={i}>
                        <img src={DiamondIcon} alt="" />
                        <p className="para">{item}</p>
                      </li>
                    ))
                  : null}
              </ul>
              <div className="footer-btn-container">
                <a
                  className="brand_light_button_container mt-4"
                  href={`https://creators.splendid.app/explore?brand_id=${brand.brand_id}`}
                >
                  Sign up Here
                </a>
              </div>
            </div>
            <div className="col col-md-6">
              <div className="image-container footer_img">
                <h3 className="footer_title2">What do I need to do as a creator?</h3>
                {yt_video ? (
                  <div className="yt-video-container">
                    <YTPlayer
                      url={yt_video}
                      config={{
                        youtube: {
                          playerVars: {
                            playsinline: 1,
                            rel: 0,
                          },
                          embedOptions: {
                            controls: 0,
                          },
                        },
                      }}
                      width="100%"
                      height="100%"
                    />
                  </div>
                ) : (
                  <img src={footer_banner} alt="" />
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="footer">
          <div className="footer_content">
            <p className="para">Powered by</p>
            <img src={splendidWhite} alt="" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default BrandPage;
